(function($){
    function resizeOverlay() {
        let vh = $(window).height();
        let headerHeight = $('.siteheader').innerHeight();
        $('.banner').each(function(index, value) {      
            $(this).css('min-height', `${vh - headerHeight}px)` );
        });
    };
    
    $(function () {
        resizeOverlay();
    });

    $(window).on( 'breakpoint_changed', resizeOverlay);
})(jQuery);